import { ASSISTER_LIST_TYPES } from '../../constants/actionTypes/entityActionTypes';

export const INITIAL_STATE = [];

export default (state= INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case ASSISTER_LIST_TYPES.SET_ASSISTER_LIST:
            return Object.assign([], action.list);
        default:
            return state;
    }
};
